export const environment = {
  production: false,
  // Base API (without trailing slash) - used to build endpoints
  apiBaseUrl: 'https://dev.letshavana.com/havana-api/api',
  // Default company name for GetCompanyJobList
  companyName: 'Qualibar Pvt Ltd'
};
